import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useCoreStore from "views/hooks/useCoreStore";

export const useSetupNavigation = () => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState<"forward" | "backward">("forward");
  const companySelected = useCoreStore(state => state.companySelected);
  const urlParams: RouteParams = useParams();

  useEffect(() => {
    if (urlParams?.menu === "setup" && companySelected) {
      setCurrent(0);
    }
  }, [companySelected]);

  const next = () => {
    setDirection("forward");
    setCurrent(current + 1);
  };

  const prev = () => {
    setDirection("backward");
    setCurrent(current - 1);
  };

  const goTo = (index: number) => {
    if (index < current) {
      setDirection("backward");
      setCurrent(index);
    }
  };

  return {
    current,
    direction,
    next,
    prev,
    goTo,
  };
};
